import type { SimilarJobData } from '@xing-com/crate-jobs-helpers';

export const orderSimilarJobs = ({
  similarJobs,
}: {
  similarJobs: SimilarJobData[];
}): SimilarJobData[] => {
  const topJobs = similarJobs.filter(({ job }) => job.topJob);
  const paidAndExternalJobs = similarJobs.filter(
    ({ job }) => !job.topJob && (job.paid || job.redirectsToThirdPartyUrl)
  );
  const unpaid = similarJobs.filter(
    ({ job }) => !job.topJob && !job.paid && !job.redirectsToThirdPartyUrl
  );
  return [...topJobs, ...paidAndExternalJobs, ...unpaid];
};
